import React from 'react'
import { ReactTyped } from 'react-typed'

const Hero = () => {
  return (
    <div className="text-white" id='home'>
      <div className="max-w-[800px] mt-[96px] w-full h-screen mx-auto text-center flex flex-col justify-center">
      <p className="text-[#00df9a] font-bold p-2 text-2xl">Senior Software Engineer</p>
      <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold md:py-6">
        Crafting Digital Experiences
      </h1>
      <div className="flex justify-center items-center mt-4">
        <p className="md:text-3xl sm:text-2xl text-lg font-semibold">
        I specialize in&nbsp;
        </p>
        <ReactTyped
        className="md:text-3xl sm:text-2xl text-lg font-semibold text-[#00df9a]"
        strings={[
          'modern web applications.',
          'robust backend systems.',
          'intuitive mobile apps.',
          'scalable cloud solutions.',
          'data-driven products.'
        ]}
        typeSpeed={70}
        backSpeed={40}
        loop
        />
      </div>
      <p className="mt-8 text-lg text-gray-300">
        With a passion for clean code and seamless user experiences, I deliver full-stack solutions that bridge design and technology. My expertise spans Java, Node.js and React, and cloud platforms, enabling businesses to innovate and grow.
      </p>
      </div>
    </div>
  )
}

export default Hero